import {
  QueryClient,
  QueryClientProvider as Provider,
} from "@tanstack/react-query";
import React from "react";

import { HOUR, MINUTE } from "$src/core/constants/time";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: MINUTE,
      gcTime: HOUR,
    },
  },
});

type Props = {
  children?: React.ReactNode;
};

const QueryProvider: React.FC<Props> = ({ children }) => (
  <Provider client={queryClient}>{children}</Provider>
);

export default QueryProvider;
